import React, { type FC, memo } from "react";
import styles from "./HighlightsHero.module.scss";
import { useCarConfigSelector } from "../../../redux/store";
import { getVisualForGradeImage } from "../../../../../../common-deprecated/settings/utils/ccisSettingUtils";

const Hero: FC = () => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const car = useCarConfigSelector((state) => state.car);
    const headerImageUrl = getVisualForGradeImage(
        commonSettings,
        car.model.id,
        car.grade.id,
        car.body.id,
        {
            type: "webp",
            padding: 700,
            bgImage: "hd-day-white",
            imageQuality: 100,
            srcSet: [
                { width: 1700, height: 800, padding: 700 },
                { width: 1000, height: 470, padding: 350 },
                { width: 500, height: 235, padding: 175 },
            ],
        },
        14,
    );
    return (
        <img
            {...headerImageUrl}
            width="1700"
            height="800"
            sizes="(max-width: 500px) 500px, (max-width: 1000px) 1000px, 1700px"
            className={styles.hero}
            loading="eager"
            alt=""
            role="presentation"
        />
    );
};

export default memo(Hero);
